import React, { useState } from 'react';
import api from '../api/axios';

/**
 * Modal de alterar senha, extraído do Dashboard.js pra ficar disponível em
 * qualquer tela (via ClientLayout) — antes só funcionava dentro do Dashboard.
 */
const ChangePasswordModal = ({ onClose }) => {
  const [passwordData, setPasswordData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [pwLoading, setPwLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordError(''); setPasswordSuccess('');
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      return setPasswordError('As senhas não coincidem');
    }
    if (passwordData.newPassword.length < 8) return setPasswordError('A senha deve ter no mínimo 8 caracteres');
    if (!/[A-Z]/.test(passwordData.newPassword)) return setPasswordError('A senha deve conter uma letra maiúscula');
    if (!/[a-z]/.test(passwordData.newPassword)) return setPasswordError('A senha deve conter uma letra minúscula');
    if (!/[0-9]/.test(passwordData.newPassword)) return setPasswordError('A senha deve conter um número');
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(passwordData.newPassword)) return setPasswordError('A senha deve conter um caractere especial');

    setPwLoading(true);
    try {
      await api.post('/auth/change-password', {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
      });
      setPasswordSuccess('Senha alterada com sucesso!');
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => { onClose(); setPasswordSuccess(''); }, 1500);
    } catch (err) {
      setPasswordError(err.response?.data?.error || 'Erro ao alterar senha');
    } finally {
      setPwLoading(false);
    }
  };

  return (
    <div className="dash-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="dash-modal">
        <div className="dash-modal-head">
          <h3>Alterar senha</h3>
          <button className="dash-modal-close" onClick={onClose}><i className="fas fa-times"></i></button>
        </div>
        {passwordError && <div className="dash-alert error">{passwordError}</div>}
        {passwordSuccess && <div className="dash-alert success">{passwordSuccess}</div>}

        <form onSubmit={handleChangePassword}>
          <div className="dash-form-group">
            <label className="dash-form-label">Senha atual</label>
            <input
              type="password"
              className="dash-form-input"
              value={passwordData.currentPassword}
              onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
              required
            />
          </div>
          <div className="dash-form-group">
            <label className="dash-form-label">Nova senha</label>
            <input
              type="password"
              className="dash-form-input"
              value={passwordData.newPassword}
              onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
              required
            />
          </div>
          <div className="dash-form-group">
            <label className="dash-form-label">Confirmar nova senha</label>
            <input
              type="password"
              className="dash-form-input"
              value={passwordData.confirmPassword}
              onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
              required
            />
          </div>
          <button type="submit" className="dash-modal-submit" disabled={pwLoading}>
            {pwLoading ? 'Salvando...' : 'Alterar senha'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
